<template>
  <HtmxPartial url="/volunteer/embed/" />
</template>

<script>
import HtmxPartial from '../components/HtmxPartial.vue';

/**
 * Mirrors the volunteerWithdrawConfirm function from volunteer.html so the
 * withdraw confirm dialog works when the page is embedded in the Vue SPA.
 * SweetAlert2 is loaded globally via index.html.
 */
function volunteerWithdrawConfirm(event, el) {
  window.Swal.fire({
    title: 'Withdraw Nomination?',
    text: 'Do you wish to withdraw your nomination? Please note if you do your position will be lost.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, Withdraw',
    cancelButtonText: 'Cancel',
  }).then(function (result) {
    if (result.isConfirmed) {
      htmx.trigger(el, 'confirmed');
    }
  });
}

export default {
  name: 'VolunteerPage',
  components: { HtmxPartial },
  mounted() {
    window.volunteerWithdrawConfirm = volunteerWithdrawConfirm;
  },
  beforeDestroy() {
    delete window.volunteerWithdrawConfirm;
  },
};
</script>
